/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.21",
    versionName: "0.2.0-nightly.2025.8.21",
    versionChannel: "nightly",
    buildDate: "2025-08-21T00:07:07.204Z",
    commitHash: "3f332924f22fc862eaf2adb8dfdd01942099f889",
};
